import api from './api';

export const membershipService = {
  async getPending() {
    const response = await api.get('/users/membership/pending');
    return response.data.data?.items || [];
  },

  async getUserMembership(userId) {
    const response = await api.get(`/users/membership/${userId}`);
    return response.data.data;
  },

  async confirm(userId, paymentId) {
    const response = await api.post(`/users/membership/${userId}/payments/${paymentId}/confirm`);
    return response.data.data;
  },

  async reject(userId, paymentId) {
    const response = await api.post(`/users/membership/${userId}/payments/${paymentId}/reject`);
    return response.data.data;
  },

  async addManualPayment(userId, { amount, paidAt, memberSince }) {
    const response = await api.post(`/users/membership/${userId}/manual`, {
      amount,
      paid_at: paidAt || 0,
      member_since: memberSince || 0,
    });
    return response.data.data;
  },
};
